import React, { useState, useEffect } from 'react';
import './login.scss';
import Button from '../Form/Button/Button';
import { withOktaAuth } from '@okta/okta-react';

/**
 * @function Timeout
 * @description Component to display session timeout message and login button.
 * @param {object} props - Component props.
 * @returns {JSX.Element} The rendered component.
 */
const Timeout = (props) => {
  const [isTabletOrAbove, setIsTabletOrAbove] = useState(window.innerWidth >= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsTabletOrAbove(window.innerWidth >= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className="login logout" style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        padding: isTabletOrAbove ? '140px 0' : undefined,
    }}>
      <h1 className="login__title login__title--margin-top">Your session has timed out due to inactivity.</h1>
      <div className="login__line">We look forward to seeing you again soon.</div>
      <div className="login__line login__margin">Would you like to log back in?</div>
      <Button customClassNames={["login__button"]} label="Log in" onClick={() => window.location.href = '/'} />
    </div>
  );
};

export default withOktaAuth(Timeout);
